import Modal, { Props } from 'react-modal';
import styled from 'styled-components';

export const Container = styled(Modal).attrs(
  () =>
    ({
      style: {
        content: {
          position: 'relative',
          width: '40rem',
          minHeight: '20rem',
          padding: '1rem',
          backgroundColor: 'white',
          outline: 'none',
          borderRadius: 13,
          boxShadow: '0px 3px 6px #00000029',
        },
      },
    } as Props),
)`
  header {
    h1 {
      font-size: 1.25rem;
      color: ${({ theme }) => theme.colors.secondary};
    }

    button {
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;

      background-color: transparent;
      border: 0;
      padding: 0;
      outline: transparent;
    }
  }
  .containerButtons {
    width: 100%;
    display: flex;
    justify-content: space-between;
    justify-items: center;
    margin-top: 1rem;
  }

  @media (max-width: 560px) {
    width: -webkit-fill-available;
    margin: 0 0.5rem;
    padding: 1rem;
    min-width: 0;
  }
`;

export const Content = styled.div`
  margin-top: 0.5rem;
`;
